import {mediaParserController} from '@remotion/media-parser';
import {parseMediaOnWebWorker} from '@remotion/media-parser/worker';

async function readDuration(file:Blob):Promise<number|null>{
  const controller=mediaParserController();
  const timer=setTimeout(()=>controller.abort(new Error('배경음 길이 확인 시간이 초과됐습니다.')),30000);
  try{return (await parseMediaOnWebWorker({src:file,fields:{slowDurationInSeconds:true},controller,acknowledgeRemotionLicense:true})).slowDurationInSeconds;}
  finally{clearTimeout(timer);}
}

/** Unknown duration is resolved from the exact downloaded file, never a guessed preview length. */
export async function resolveBgmDuration(file:Blob,knownMilliseconds:number|null,probe=readDuration):Promise<number>{
  if(knownMilliseconds!==null){
    if(!Number.isFinite(knownMilliseconds)||knownMilliseconds<=0)throw new Error('실제 오디오 길이를 확인해 주세요.');
    return knownMilliseconds;
  }
  console.debug('[QA BGM] resolving unknown duration from dropped file');
  const seconds=await probe(file);
  if(seconds===null||!Number.isFinite(seconds)||seconds<=0)throw new Error('배경음 원본 길이를 확인하지 못했습니다.');
  const milliseconds=seconds*1000;
  if(!Number.isFinite(milliseconds))throw new Error('배경음 원본 길이를 확인하지 못했습니다.');
  return milliseconds;
}
